var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import query from 'syf-component-library/const/mediaQueries';
import Stack from 'syf-component-library/ui/spacing/Stack';
import { getCurrentRouteSection } from '../../../helpers';
import { RenderIf } from 'syf-component-library/ui/atoms';
import { Routes } from '../../../const';
import useMediaQuery from '../../../hooks/use-media-query';
import useTranslation from '../../../hooks/use-translation';
import HandHoldingHeartGraphic from '../../common/HandHoldingHeartGraphic';
import { StyledFlex, StyledText } from '../../subcomponents';
import { StyledMessage, StyledNote, StyledStart } from './subcomponents';
import useTriggerAnalyticsEvent from '../../../helpers/triggerAnalyticsEvent';
import { useMainContext } from '../../../context';
var Start = function () {
    var i18n = useTranslation();
    var currentRoute = useMainContext().currentRoute;
    var isMobile = useMediaQuery(query.lessThanSmall);
    var routeName = getCurrentRouteSection(currentRoute);
    var analyticsEvent = "".concat(routeName, "Start");
    useTriggerAnalyticsEvent({
        featureEvent: analyticsEvent,
        currentRoute: currentRoute
    });
    return (_jsxs(StyledStart, { children: [_jsx(StyledFlex, __assign({ justifyContent: "center" }, { children: _jsx(HandHoldingHeartGraphic, { width: isMobile ? 100 : 155 }) })), _jsxs(StyledFlex, __assign({ direction: "column", justifyContent: "space-between", alignItems: "center" }, { children: [_jsx(Stack, { size: "large" }), _jsx(StyledText, __assign({ weight: "bold", size: "medium", align: "center" }, { children: i18n('settlement.startHeading') })), _jsx(Stack, {}), _jsx(StyledMessage, __assign({ align: "center" }, { children: i18n('settlement.startSubheading') })), _jsx(RenderIf, __assign({ condition: currentRoute === Routes.SETTLEMENT_START }, { children: _jsxs(_Fragment, { children: [_jsx(Stack, { size: "large" }), _jsx(Stack, { size: "large" }), _jsxs(StyledNote, { children: [_jsx(StyledText, __assign({ weight: "bold", size: "regular", display: "inline" }, { children: i18n('settlement.startNoteText').slice(0, 6) })), _jsx(StyledText, __assign({ size: "regular", display: "inline" }, { children: i18n('settlement.startNoteText').slice(5) }))] })] }) }))] }))] }));
};
export default Start;
//# sourceMappingURL=index.js.map